var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef, memo } from "react";

var SvgBigQuotes = function SvgBigQuotes(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 273 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M109.051 54.4352V0H54.5253V54.4352H109.051ZM273 54.4352V0H218.475V54.4352H273ZM109.051 217V108.5H54.5253V54.4352H0V217H109.051ZM273 217V108.5H218.475V54.4352H163.576V217H273Z",
    fill: "#ffffff"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgBigQuotes);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyAgdmlld0JveD0iMCAwIDI3MyAyMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIG9wYWNpdHk9IjAuMSIgZD0iTTEwOS4wNTEgNTQuNDM1MlYwSDU0LjUyNTNWNTQuNDM1MkgxMDkuMDUxWk0yNzMgNTQuNDM1MlYwSDIxOC40NzVWNTQuNDM1MkgyNzNaTTEwOS4wNTEgMjE3VjEwOC41SDU0LjUyNTNWNTQuNDM1MkgwVjIxN0gxMDkuMDUxWk0yNzMgMjE3VjEwOC41SDIxOC40NzVWNTQuNDM1MkgxNjMuNTc2VjIxN0gyNzNaIiBmaWxsPSIjZmZmZmZmIi8+Cjwvc3ZnPgo=";